<div [ngClass]="{ open: svc.open, hide: hideNav }" class="side-navigator-container" (mouseenter)="showExpandCollapse($event)" (mouseleave)="hideExpandCollapse($event)">
  <div class="side-navigator-header-container">
    @if (false && (svc.area === 'Network' || svc.area === 'ZAC' || svc.area === 'Support_Operations')) {
      <div class="networks">
        <div (click)="toggleList($event)" class="currentNetwork" id="currentNetwork">
          {{ svc.currentNetwork.name }}
        </div>
        <div [ngClass]="{ opened: isOpened }" class="shadow" id="Networks">
          <div class="row">
            <div (click)="toggleList($event)" class="currentNetwork">
              {{ svc.currentNetwork.name }}
            </div>
          </div>
          <div id="ListArea">
            <div class="list-area search row">
              <input
                (click)="stopProp($event)"
                [(ngModel)]="filterString"
                id="SearchNetworks"
                placeholder="Type to Filter"
                type="text"
                />
            </div>
            <div class="headerNetworkList row">
              @for (networkModel of svc.allNetworks | tableSearch: filterString | sortby: 'name'; track networkModel) {
                <div
                  (click)="setNetwork(networkModel)"
                  class="selectNetwork row"
                  >
                  <div class="status s{{ networkModel.status }}" id="nStatList{{ networkModel.id }}">
                    <div class="anim5"></div>
                  </div>
                  {{ networkModel.name }}
                </div>
              }
              @if (authorizationService.canCreateNetworks()) {
                <div
                  (click)="svc.addNetwork()"
                  class="item row"
                  id="AddNetworkButton"
                  >
                  <div class="icon append icon-BigSoftPlus"></div>
                  <div class="content">Add a New Network</div>
                </div>
              }
            </div>
            <!--          <div *ngIf="!featureService.experimentalFeatures" id="ManageNetworkButton" class="navItem" routerLink="/networks">Manage Networks</div>-->
            <div class="navItem" id="ManageNetworkButton" routerLink="/networks">Manage Networks</div>
          </div>
        </div>
      </div>
    }
    @if (svc.area === 'Network' || svc.area === 'ZAC' || svc.area === 'Support_Operations') {
      <lib-item-selector
        [currentItem]="svc.currentNetwork"
        [isOpened]="isOpened"
        [items]="svc.allNetworks"
        [addNewItemLabel]="'Add a New Network'"
        [manageItemsLabel]="'Manage Networks'"
        [manageItemsLink]="'/networks'"
        [showAddNewItem]="authorizationService.canCreateNetworks()"
        (currentItemChange)="setNetwork($event)"
        (addNewItem)="svc.addNetwork()"
        [(filterString)]="filterString"
        >
      </lib-item-selector>
      @if (featureService.zitiOverlayEnabled) {
        <lib-ziti-status-indicator></lib-ziti-status-indicator>
      }
    }
    @if (showOrgPicker && !featureService.isCloudZiti) {
      <div (clickOutside)="closeList()" class="tenantArea">
        <div class="tenants">
          <div (click)="toggleList($event)" class="currentTenant" id="currentTenant">
            {{ svc.currentTenant ? svc.currentTenant.name : '' }}
          </div>
          <div [ngClass]="{ opened: isOpened }" class="shadow" id="Tenants">
            <div class="row">
              <div (click)="toggleList($event)" class="currentTenant">
                {{ svc.currentTenant ? svc.currentTenant.name : '' }}
              </div>
            </div>
            <div id="ListArea">
              <div class="list-area search row">
                <input
                  (click)="stopProp($event)"
                  [(ngModel)]="filterString"
                  id="SearchTenants"
                  placeholder="Type to Filter"
                  type="text"
                  />
              </div>
              <div class="headerTenantList row">
                @for (tenantModel of svc.tenants | tableSearch: filterString | sortby: 'name'; track tenantModel) {
                  <div
                    (click)="setTenant(tenantModel)"
                    [ngClass]="{ selected: svc.currentTenant.id === tenantModel.id }"
                    class="selectNetwork row"
                    >
                    <div class="orgStatus s300" id="nStatList{{ tenantModel.id }}">
                      <div class="anim5"></div>
                    </div>
                    {{ tenantModel.name }}
                  </div>
                }
                @if (authorizationService.canCreateTenant()) {
                  <div
                    (click)="svc.addTenant()"
                    class="item row"
                    id="AddTenantButton"
                    >
                    <div class="icon append icon-BigSoftPlus"></div>
                    <div class="content">Add a New Organization</div>
                  </div>
                }
              </div>
              <div [routerLink]="Organizations" class="navItem" id="ManageTenantsButtons">
                Manage Organizations
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (showOrgPicker && featureService.isCloudZiti) {
      <div (clickOutside)="closeList()" class="tenantArea organizationsArea">
        <div class="tenants">
          <div (click)="toggleList($event)" class="currentTenant" id="currentTenant" title="{{getRealmPrefix(svc.currentOrganization)}} {{ svc.currentOrganization ? svc.currentOrganization.name : '' }}">
            {{getRealmPrefix(svc.currentOrganization)}} {{ svc.currentOrganization ? svc.currentOrganization.name : '' }}
          </div>
          <div [ngClass]="{ opened: isOpened }" class="shadow" id="Tenants">
            <div class="row">
              <div (click)="toggleList($event)" class="currentTenant" title="{{getRealmPrefix(svc.currentOrganization)}} {{ svc.currentOrganization ? svc.currentOrganization.name : '' }}">
                {{getRealmPrefix(svc.currentOrganization)}} {{ svc.currentOrganization ? svc.currentOrganization.name : '' }}
              </div>
            </div>
            <div id="ListArea">
              <div class="list-area search row">
                <input
                  (click)="stopProp($event)"
                  [(ngModel)]="filterString"
                  id="SearchTenants"
                  placeholder="Type to Filter"
                  type="text"
                  />
              </div>
              <div class="headerTenantList row">
                @for (organizationModel of svc.organizations | tableSearch: filterString | sortby: 'name'; track organizationModel) {
                  <div
                    (click)="setOrganization(organizationModel)"
                    [ngClass]="{ selected: organizationSelected(organizationModel) }"
                    class="selectNetwork row"
                    >
                    <div class="orgStatus s300" id="nStatList{{ organizationModel.id }}">
                      <div class="anim5"></div>
                    </div>
                    {{getRealmPrefix(organizationModel)}} {{ organizationModel.name }}
                  </div>
                }
                @if (authorizationService.canCreateTenant()) {
                  <div
                    (click)="svc.addTenant()"
                    class="item row"
                    id="AddTenantButton"
                    >
                    <div class="icon append icon-BigSoftPlus"></div>
                    <div class="content">Add a New Organization</div>
                  </div>
                }
              </div>
              <div [routerLink]="Organizations" class="navItem" id="ManageTenantsButtons">
                Manage Organizations
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (showCustomerPicker) {
      <div (clickOutside)="closeList()" class="customerArea">
        <div class="customers">
          <div (click)="toggleList($event)" class="currentCustomer" id="currentCustomer">
            {{ svc.currentCustomer.name }}
          </div>
          <div [ngClass]="{ opened: isOpened }" class="shadow" id="Customers">
            <div class="row">
              <div (click)="toggleList($event)" class="currentCustomer">
                {{ svc.currentCustomer.name }}
              </div>
            </div>
            <div id="ListArea">
              <div class="list-area search row">
                <input
                  (click)="stopProp($event)"
                  [(ngModel)]="filterString"
                  id="SearchCustomers"
                  placeholder="Type to Filter"
                  type="text"
                  />
              </div>
              <div class="headerCustomerList row">
                @for (customer of svc.customers | tableSearch: filterString | sortby: 'name'; track customer) {
                  <div
                    (click)="setCustomer(customer)"
                    [ngClass]="{ selected: svc.currentCustomer.id === customer.id }"
                    class="selectNetwork row"
                    >
                    <div class="orgStatus s300" id="nStatList{{ customer.id }}">
                      <div class="anim5"></div>
                    </div>
                    {{ customer.name }}
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    @if (!hideTitle) {
      <div class="title">{{ svc.currentNav.title }}</div>
    }
  </div>
  <div cdkScrollable class="side-navigator-menu-container" [ngClass]="{'hide-menu-nav-bar': hideMenuNavBar}">
    @for (group of svc.currentNav.groups; track group) {
      <div class="side-navigator-menu-group">
        @if (!group.experimental || featureService.experimentalFeatures) {
          <div>
            @if (!group.hideLabel && !hideFdGroup(group)) {
              <span class="side-navigator-menu-group-label">{{ group.label }}</span>
            }
            @if (group.headerBuffer) {
              <div class="side-navigator-header-buffer"></div>
            }
            @for (item of group.menuItems; track item) {
              <div class="{{item.class}}">
                @if ((item.route !== networkControllerURL || authorizationService.canUpdateNetwork(currentNetwork.id)) &&
                  !(item.route === latencyUrl && !featureService.experimentalFeatures) &&
                  !(item.route === ctlLatencyUrl && !featureService.experimentalFeatures) &&
                  ((!item.enterpriseOnly && !item.selfServiceOnly) ||
                  (item.enterpriseOnly && enterpriseBilling) ||
                  (item.selfServiceOnly && !enterpriseBilling)) &&
                  (!hideMenuItem(item))
                  && (item.route !== cloudzitiBillingURL)
                  ) {
                  <div
                    class="side-navigator-menu-item {{ item.className }}"
                    (click)="doNavAction(item)"
                        [ngClass]="{
                            selected: navItemSelected(item),
                            disabled: svc.isNavItemDisabled(item) || disableNavigation
                        }"
                        [title]="
                        svc.disableMainNav && item.requiresAgent ? agentDisabledToolTip :
                        svc.disableMainNav && item.requiresProvision ? disabledToolTip : ''"
                    >
                    <div class="side-navigator-menu-item-icon">
                      @if (item.faIcon) {
                        <fa-icon
                          class="image image--fa"
                          [icon]="item.faIcon"
                          [class.is-running]="isMenuItemRunning(item)"
                        ></fa-icon>
                      } @else {
                        <div
                          class="image"
                          [ngClass]="item.iconClass"
                          [class.is-running]="isMenuItemRunning(item)"
                        ></div>
                      }
                      @if (item.badgeCount) {
                        <span class="counterBadge">{{ item.badgeCount }}</span>
                      }
                    </div>
                    <span class="side-navigator-menu-item-label">
                      {{ item.label }}
                      <span class="side-navigator-menu-item-sublabel">{{ item.sublabel }}</span>
                    </span>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
  <div class="side-navigator-footer-container">
    @if (brandingModeService.logosAvailable || environment.showDefaultLogo) {
      <div
        [ngClass]="{ dark: brandingService.darkModeEnabled }"
        class="navlogo"
      ></div>
    }
    <div class="side-navigator-version-container">
      @if (currentNetwork.id) {
        <div class="networkInfo" id="NetworkVersion">
          Platform Version: <span class="network-semver">{{ majorVersionNumber }}.{{ minorVersionNumber }}.{{ patchVersionNumber }}</span>
        </div>
      }
      @if (currentZitiEdgeDetails.zitiVersion) {
        <div class="zitiInfo" id="ZitiVersion">
          Ziti Version: <span class="ziti-semver">{{ currentZitiEdgeDetails.zitiVersion }}</span>
        </div>
      }
      <div
        (click)="toggleLock()"
        [ngClass]="{ locked: menuService.locked }"
        class="lock-icon"
        id="MenuLock"
        title="Lock Menu Open"
      ></div>
    </div>
  </div>
</div>
@if (featureService.isCloudZiti) {
  <div class="expand-collapse-hitbox-container" [ngClass]="{'expand-collapse-container-closed': !svc.open}" (mouseenter)="showExpandCollapse($event)" (mouseleave)="hideExpandCollapse($event)">
    <div class="expand-collapse-icon icon-prev" [ngClass]="{'expand-collapse-icon-visible': this.expandCollapseIconVisible}" (click)="collapseNav($event)"></div>
  </div>
}
